import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _767c8bc8 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _5a65a8d7 = () => interopDefault(import('../pages/c46est27adj/index.vue' /* webpackChunkName: "pages/c46est27adj/index" */))
const _3d53ac46 = () => interopDefault(import('../pages/chatwoot-app.vue' /* webpackChunkName: "pages/chatwoot-app" */))
const _60d70436 = () => interopDefault(import('../pages/componentsTest.vue' /* webpackChunkName: "pages/componentsTest" */))
const _a328d5a6 = () => interopDefault(import('../pages/documentation.vue' /* webpackChunkName: "pages/documentation" */))
const _2135eeaa = () => interopDefault(import('../pages/new_landing.vue' /* webpackChunkName: "pages/new_landing" */))
const _7ad10a9c = () => interopDefault(import('../pages/old_landing.vue' /* webpackChunkName: "pages/old_landing" */))
const _70a9c790 = () => interopDefault(import('../pages/onboarding.vue' /* webpackChunkName: "pages/onboarding" */))
const _52ec494c = () => interopDefault(import('../pages/org/index.vue' /* webpackChunkName: "pages/org/index" */))
const _710685e6 = () => interopDefault(import('../pages/TestMail.vue' /* webpackChunkName: "pages/TestMail" */))
const _57e2e98c = () => interopDefault(import('../pages/admin/locales.vue' /* webpackChunkName: "pages/admin/locales" */))
const _4e5f7dfa = () => interopDefault(import('../pages/admin/settings/index.vue' /* webpackChunkName: "pages/admin/settings/index" */))
const _63afdce2 = () => interopDefault(import('../pages/auth/recovery.vue' /* webpackChunkName: "pages/auth/recovery" */))
const _1722dc83 = () => interopDefault(import('../pages/case/elis.vue' /* webpackChunkName: "pages/case/elis" */))
const _5c248024 = () => interopDefault(import('../pages/case/luna.vue' /* webpackChunkName: "pages/case/luna" */))
const _40c8f867 = () => interopDefault(import('../pages/case/selfservice.vue' /* webpackChunkName: "pages/case/selfservice" */))
const _6e67fdce = () => interopDefault(import('../pages/admin/settings/control.vue' /* webpackChunkName: "pages/admin/settings/control" */))
const _a76972e2 = () => interopDefault(import('../pages/admin/settings/notification-create.vue' /* webpackChunkName: "pages/admin/settings/notification-create" */))
const _c997edce = () => interopDefault(import('../pages/admin/settings/notifications.vue' /* webpackChunkName: "pages/admin/settings/notifications" */))
const _d98c4108 = () => interopDefault(import('../pages/admin/settings/partner/index.vue' /* webpackChunkName: "pages/admin/settings/partner/index" */))
const _cf1377e2 = () => interopDefault(import('../pages/admin/settings/partner/update.vue' /* webpackChunkName: "pages/admin/settings/partner/update" */))
const _53641a45 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _22c1a4cd = () => interopDefault(import('../pages/client/department/_departmentId/record/index.vue' /* webpackChunkName: "pages/client/department/_departmentId/record/index" */))
const _09a53acb = () => interopDefault(import('../pages/client/department/_departmentId/record/deprecated/index.vue' /* webpackChunkName: "pages/client/department/_departmentId/record/deprecated/index" */))
const _3fecaee0 = () => interopDefault(import('../pages/client/_resultId.vue' /* webpackChunkName: "pages/client/_resultId" */))
const _6559d246 = () => interopDefault(import('../pages/confirm-record/_id.vue' /* webpackChunkName: "pages/confirm-record/_id" */))
const _71c61c5a = () => interopDefault(import('../pages/l/_slug.vue' /* webpackChunkName: "pages/l/_slug" */))
const _69d69f7c = () => interopDefault(import('../pages/client/_clientId/about-me/index.vue' /* webpackChunkName: "pages/client/_clientId/about-me/index" */))
const _d6ef377c = () => interopDefault(import('../pages/client/_clientId/my-records.vue' /* webpackChunkName: "pages/client/_clientId/my-records" */))
const _59806a16 = () => interopDefault(import('../pages/client/_clientId/record/index.vue' /* webpackChunkName: "pages/client/_clientId/record/index" */))
const _44372a7f = () => interopDefault(import('../pages/org/_orgId/analytics.vue' /* webpackChunkName: "pages/org/_orgId/analytics" */))
const _16b395c2 = () => interopDefault(import('../pages/org/_orgId/analytics/index.vue' /* webpackChunkName: "pages/org/_orgId/analytics/index" */))
const _1db6f1f8 = () => interopDefault(import('../pages/org/_orgId/analytics/clients.vue' /* webpackChunkName: "pages/org/_orgId/analytics/clients" */))
const _279282ca = () => interopDefault(import('../pages/org/_orgId/analytics/finance.vue' /* webpackChunkName: "pages/org/_orgId/analytics/finance" */))
const _d036cfa8 = () => interopDefault(import('../pages/org/_orgId/analytics/operations.vue' /* webpackChunkName: "pages/org/_orgId/analytics/operations" */))
const _7530fa04 = () => interopDefault(import('../pages/org/_orgId/clients/index.vue' /* webpackChunkName: "pages/org/_orgId/clients/index" */))
const _bd9f818e = () => interopDefault(import('../pages/org/_orgId/integrations/index.vue' /* webpackChunkName: "pages/org/_orgId/integrations/index" */))
const _2edb8b61 = () => interopDefault(import('../pages/org/_orgId/kkt-shifts.vue' /* webpackChunkName: "pages/org/_orgId/kkt-shifts" */))
const _92e5d3dc = () => interopDefault(import('../pages/org/_orgId/promotionTools/index.vue' /* webpackChunkName: "pages/org/_orgId/promotionTools/index" */))
const _3b3cbab0 = () => interopDefault(import('../pages/org/_orgId/record.vue' /* webpackChunkName: "pages/org/_orgId/record" */))
const _2c050e86 = () => interopDefault(import('../pages/org/_orgId/settings/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/index" */))
const _0b7ba70b = () => interopDefault(import('../pages/org/_orgId/support/index.vue' /* webpackChunkName: "pages/org/_orgId/support/index" */))
const _3e510dfb = () => interopDefault(import('../pages/org/_orgId/tariff.vue' /* webpackChunkName: "pages/org/_orgId/tariff" */))
const _73562b84 = () => interopDefault(import('../pages/client/_clientId/deprecated/indexAboutme.vue' /* webpackChunkName: "pages/client/_clientId/deprecated/indexAboutme" */))
const _26b85bf0 = () => interopDefault(import('../pages/client/_clientId/deprecated/indexRecord.vue' /* webpackChunkName: "pages/client/_clientId/deprecated/indexRecord" */))
const _570a635a = () => interopDefault(import('../pages/org/_orgId/clients/categories.vue' /* webpackChunkName: "pages/org/_orgId/clients/categories" */))
const _b6699728 = () => interopDefault(import('../pages/org/_orgId/deprecated/departEmployees.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/departEmployees" */))
const _053da3d2 = () => interopDefault(import('../pages/org/_orgId/deprecated/departInfo.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/departInfo" */))
const _1f53ee1c = () => interopDefault(import('../pages/org/_orgId/deprecated/departmentPosts.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/departmentPosts" */))
const _64a0050e = () => interopDefault(import('../pages/org/_orgId/deprecated/posts.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/posts" */))
const _53205b82 = () => interopDefault(import('../pages/org/_orgId/deprecated/servicesEmployees.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/servicesEmployees" */))
const _a32c6960 = () => interopDefault(import('../pages/org/_orgId/deprecated/servicesPosts.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/servicesPosts" */))
const _13ea7bb8 = () => interopDefault(import('../pages/org/_orgId/deprecated/unusedCode.vue' /* webpackChunkName: "pages/org/_orgId/deprecated/unusedCode" */))
const _1f085d44 = () => interopDefault(import('../pages/org/_orgId/integrations/kkm_server.vue' /* webpackChunkName: "pages/org/_orgId/integrations/kkm_server" */))
const _78c16de7 = () => interopDefault(import('../pages/org/_orgId/integrations/rostelecom-cloudpbx/index.vue' /* webpackChunkName: "pages/org/_orgId/integrations/rostelecom-cloudpbx/index" */))
const _4bff6485 = () => interopDefault(import('../pages/org/_orgId/promotionTools/selectDepartments.vue' /* webpackChunkName: "pages/org/_orgId/promotionTools/selectDepartments" */))
const _71d77ed0 = () => interopDefault(import('../pages/org/_orgId/settings/activePosts.vue' /* webpackChunkName: "pages/org/_orgId/settings/activePosts" */))
const _4ec54bf8 = () => interopDefault(import('../pages/org/_orgId/settings/branches/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/branches/index" */))
const _7ce9adcc = () => interopDefault(import('../pages/org/_orgId/settings/carCompanies.vue' /* webpackChunkName: "pages/org/_orgId/settings/carCompanies" */))
const _400d3041 = () => interopDefault(import('../pages/org/_orgId/settings/categories.vue' /* webpackChunkName: "pages/org/_orgId/settings/categories" */))
const _1a8b259e = () => interopDefault(import('../pages/org/_orgId/settings/client-form.vue' /* webpackChunkName: "pages/org/_orgId/settings/client-form" */))
const _51f94d8c = () => interopDefault(import('../pages/org/_orgId/settings/departments.vue' /* webpackChunkName: "pages/org/_orgId/settings/departments" */))
const _4700ca15 = () => interopDefault(import('../pages/org/_orgId/settings/departmetMaster.vue' /* webpackChunkName: "pages/org/_orgId/settings/departmetMaster" */))
const _2d50821a = () => interopDefault(import('../pages/org/_orgId/settings/employees/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/employees/index" */))
const _1eef4f0a = () => interopDefault(import('../pages/org/_orgId/settings/finishSettings.vue' /* webpackChunkName: "pages/org/_orgId/settings/finishSettings" */))
const _dc5c2248 = () => interopDefault(import('../pages/org/_orgId/settings/lk-settings.vue' /* webpackChunkName: "pages/org/_orgId/settings/lk-settings" */))
const _ab6567e2 = () => interopDefault(import('../pages/org/_orgId/settings/models.vue' /* webpackChunkName: "pages/org/_orgId/settings/models" */))
const _263dc316 = () => interopDefault(import('../pages/org/_orgId/settings/notifications/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/notifications/index" */))
const _e4513e6c = () => interopDefault(import('../pages/org/_orgId/settings/online-record-settings.vue' /* webpackChunkName: "pages/org/_orgId/settings/online-record-settings" */))
const _f9a42256 = () => interopDefault(import('../pages/org/_orgId/settings/positions.vue' /* webpackChunkName: "pages/org/_orgId/settings/positions" */))
const _59fa4d54 = () => interopDefault(import('../pages/org/_orgId/settings/profile.vue' /* webpackChunkName: "pages/org/_orgId/settings/profile" */))
const _30249ed6 = () => interopDefault(import('../pages/org/_orgId/settings/pwa-setup.vue' /* webpackChunkName: "pages/org/_orgId/settings/pwa-setup" */))
const _9ff89df4 = () => interopDefault(import('../pages/org/_orgId/settings/services/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/services/index" */))
const _49eb8e10 = () => interopDefault(import('../pages/org/_orgId/settings/startSettings.vue' /* webpackChunkName: "pages/org/_orgId/settings/startSettings" */))
const _3d77c492 = () => interopDefault(import('../pages/org/_orgId/settings/test-kkm.vue' /* webpackChunkName: "pages/org/_orgId/settings/test-kkm" */))
const _824253c4 = () => interopDefault(import('../pages/org/_orgId/settings/wallet.vue' /* webpackChunkName: "pages/org/_orgId/settings/wallet" */))
const _6b94dd6a = () => interopDefault(import('../pages/org/_orgId/integrations/rostelecom-cloudpbx/calls.vue' /* webpackChunkName: "pages/org/_orgId/integrations/rostelecom-cloudpbx/calls" */))
const _17599bc0 = () => interopDefault(import('../pages/org/_orgId/settings/employees/schedules/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/employees/schedules/index" */))
const _1b53f0e0 = () => interopDefault(import('../pages/org/_orgId/settings/employees/services/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/employees/services/index" */))
const _0f7ad50d = () => interopDefault(import('../pages/org/_orgId/settings/notifications/list/index.vue' /* webpackChunkName: "pages/org/_orgId/settings/notifications/list/index" */))
const _443675af = () => interopDefault(import('../pages/org/_orgId/settings/services/reorder.vue' /* webpackChunkName: "pages/org/_orgId/settings/services/reorder" */))
const _74369296 = () => interopDefault(import('../pages/org/_orgId/settings/notifications/list/_id.vue' /* webpackChunkName: "pages/org/_orgId/settings/notifications/list/_id" */))
const _7ff2b23c = () => interopDefault(import('../pages/org/_orgId/settings/branches/_branchId.vue' /* webpackChunkName: "pages/org/_orgId/settings/branches/_branchId" */))
const _6ffcd62d = () => interopDefault(import('../pages/org/_orgId/settings/services/_serviceId.vue' /* webpackChunkName: "pages/org/_orgId/settings/services/_serviceId" */))
const _a3e1af9c = () => interopDefault(import('../pages/org/_orgId/calendar/_departmentId.vue' /* webpackChunkName: "pages/org/_orgId/calendar/_departmentId" */))
const _b60738cc = () => interopDefault(import('../pages/org/_orgId/clients/_clientId/index.vue' /* webpackChunkName: "pages/org/_orgId/clients/_clientId/index" */))
const _204c07fc = () => interopDefault(import('../pages/org/_orgId/employee/_employeeId/about-me/index.vue' /* webpackChunkName: "pages/org/_orgId/employee/_employeeId/about-me/index" */))
const _69cfabfb = () => interopDefault(import('../pages/org/_orgId/employee/_employeeId/schedule/index.vue' /* webpackChunkName: "pages/org/_orgId/employee/_employeeId/schedule/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth",
    component: _767c8bc8,
    name: "auth"
  }, {
    path: "/c46est27adj",
    component: _5a65a8d7,
    name: "c46est27adj"
  }, {
    path: "/chatwoot-app",
    component: _3d53ac46,
    name: "chatwoot-app"
  }, {
    path: "/componentsTest",
    component: _60d70436,
    name: "componentsTest"
  }, {
    path: "/documentation",
    component: _a328d5a6,
    name: "documentation"
  }, {
    path: "/new_landing",
    component: _2135eeaa,
    name: "new_landing"
  }, {
    path: "/old_landing",
    component: _7ad10a9c,
    name: "old_landing"
  }, {
    path: "/onboarding",
    component: _70a9c790,
    name: "onboarding"
  }, {
    path: "/org",
    component: _52ec494c,
    name: "org"
  }, {
    path: "/TestMail",
    component: _710685e6,
    name: "TestMail"
  }, {
    path: "/admin/locales",
    component: _57e2e98c,
    name: "admin-locales"
  }, {
    path: "/admin/settings",
    component: _4e5f7dfa,
    name: "admin-settings"
  }, {
    path: "/auth/recovery",
    component: _63afdce2,
    name: "auth-recovery"
  }, {
    path: "/case/elis",
    component: _1722dc83,
    name: "case-elis"
  }, {
    path: "/case/luna",
    component: _5c248024,
    name: "case-luna"
  }, {
    path: "/case/selfservice",
    component: _40c8f867,
    name: "case-selfservice"
  }, {
    path: "/admin/settings/control",
    component: _6e67fdce,
    name: "admin-settings-control"
  }, {
    path: "/admin/settings/notification-create",
    component: _a76972e2,
    name: "admin-settings-notification-create"
  }, {
    path: "/admin/settings/notifications",
    component: _c997edce,
    name: "admin-settings-notifications"
  }, {
    path: "/admin/settings/partner",
    component: _d98c4108,
    name: "admin-settings-partner"
  }, {
    path: "/admin/settings/partner/update",
    component: _cf1377e2,
    name: "admin-settings-partner-update"
  }, {
    path: "/",
    component: _53641a45,
    name: "index"
  }, {
    path: "/client/department/:departmentId?/record",
    component: _22c1a4cd,
    name: "client-department-departmentId-record"
  }, {
    path: "/client/department/:departmentId?/record/deprecated",
    component: _09a53acb,
    name: "client-department-departmentId-record-deprecated"
  }, {
    path: "/client/:resultId?",
    component: _3fecaee0,
    name: "client-resultId"
  }, {
    path: "/confirm-record/:id?",
    component: _6559d246,
    name: "confirm-record-id"
  }, {
    path: "/l/:slug?",
    component: _71c61c5a,
    name: "l-slug"
  }, {
    path: "/client/:clientId?/about-me",
    component: _69d69f7c,
    name: "client-clientId-about-me"
  }, {
    path: "/client/:clientId?/my-records",
    component: _d6ef377c,
    name: "client-clientId-my-records"
  }, {
    path: "/client/:clientId?/record",
    component: _59806a16,
    name: "client-clientId-record"
  }, {
    path: "/org/:orgId/analytics",
    component: _44372a7f,
    children: [{
      path: "",
      component: _16b395c2,
      name: "org-orgId-analytics"
    }, {
      path: "clients",
      component: _1db6f1f8,
      name: "org-orgId-analytics-clients"
    }, {
      path: "finance",
      component: _279282ca,
      name: "org-orgId-analytics-finance"
    }, {
      path: "operations",
      component: _d036cfa8,
      name: "org-orgId-analytics-operations"
    }]
  }, {
    path: "/org/:orgId/clients",
    component: _7530fa04,
    name: "org-orgId-clients"
  }, {
    path: "/org/:orgId/integrations",
    component: _bd9f818e,
    name: "org-orgId-integrations"
  }, {
    path: "/org/:orgId/kkt-shifts",
    component: _2edb8b61,
    name: "org-orgId-kkt-shifts"
  }, {
    path: "/org/:orgId/promotionTools",
    component: _92e5d3dc,
    name: "org-orgId-promotionTools"
  }, {
    path: "/org/:orgId/record",
    component: _3b3cbab0,
    name: "org-orgId-record"
  }, {
    path: "/org/:orgId/settings",
    component: _2c050e86,
    name: "org-orgId-settings"
  }, {
    path: "/org/:orgId/support",
    component: _0b7ba70b,
    name: "org-orgId-support"
  }, {
    path: "/org/:orgId/tariff",
    component: _3e510dfb,
    name: "org-orgId-tariff"
  }, {
    path: "/client/:clientId?/deprecated/indexAboutme",
    component: _73562b84,
    name: "client-clientId-deprecated-indexAboutme"
  }, {
    path: "/client/:clientId?/deprecated/indexRecord",
    component: _26b85bf0,
    name: "client-clientId-deprecated-indexRecord"
  }, {
    path: "/org/:orgId/clients/categories",
    component: _570a635a,
    name: "org-orgId-clients-categories"
  }, {
    path: "/org/:orgId/deprecated/departEmployees",
    component: _b6699728,
    name: "org-orgId-deprecated-departEmployees"
  }, {
    path: "/org/:orgId/deprecated/departInfo",
    component: _053da3d2,
    name: "org-orgId-deprecated-departInfo"
  }, {
    path: "/org/:orgId/deprecated/departmentPosts",
    component: _1f53ee1c,
    name: "org-orgId-deprecated-departmentPosts"
  }, {
    path: "/org/:orgId/deprecated/posts",
    component: _64a0050e,
    name: "org-orgId-deprecated-posts"
  }, {
    path: "/org/:orgId/deprecated/servicesEmployees",
    component: _53205b82,
    name: "org-orgId-deprecated-servicesEmployees"
  }, {
    path: "/org/:orgId/deprecated/servicesPosts",
    component: _a32c6960,
    name: "org-orgId-deprecated-servicesPosts"
  }, {
    path: "/org/:orgId/deprecated/unusedCode",
    component: _13ea7bb8,
    name: "org-orgId-deprecated-unusedCode"
  }, {
    path: "/org/:orgId/integrations/kkm_server",
    component: _1f085d44,
    name: "org-orgId-integrations-kkm_server"
  }, {
    path: "/org/:orgId/integrations/rostelecom-cloudpbx",
    component: _78c16de7,
    name: "org-orgId-integrations-rostelecom-cloudpbx"
  }, {
    path: "/org/:orgId/promotionTools/selectDepartments",
    component: _4bff6485,
    name: "org-orgId-promotionTools-selectDepartments"
  }, {
    path: "/org/:orgId/settings/activePosts",
    component: _71d77ed0,
    name: "org-orgId-settings-activePosts"
  }, {
    path: "/org/:orgId/settings/branches",
    component: _4ec54bf8,
    name: "org-orgId-settings-branches"
  }, {
    path: "/org/:orgId/settings/carCompanies",
    component: _7ce9adcc,
    name: "org-orgId-settings-carCompanies"
  }, {
    path: "/org/:orgId/settings/categories",
    component: _400d3041,
    name: "org-orgId-settings-categories"
  }, {
    path: "/org/:orgId/settings/client-form",
    component: _1a8b259e,
    name: "org-orgId-settings-client-form"
  }, {
    path: "/org/:orgId/settings/departments",
    component: _51f94d8c,
    name: "org-orgId-settings-departments"
  }, {
    path: "/org/:orgId/settings/departmetMaster",
    component: _4700ca15,
    name: "org-orgId-settings-departmetMaster"
  }, {
    path: "/org/:orgId/settings/employees",
    component: _2d50821a,
    name: "org-orgId-settings-employees"
  }, {
    path: "/org/:orgId/settings/finishSettings",
    component: _1eef4f0a,
    name: "org-orgId-settings-finishSettings"
  }, {
    path: "/org/:orgId/settings/lk-settings",
    component: _dc5c2248,
    name: "org-orgId-settings-lk-settings"
  }, {
    path: "/org/:orgId/settings/models",
    component: _ab6567e2,
    name: "org-orgId-settings-models"
  }, {
    path: "/org/:orgId/settings/notifications",
    component: _263dc316,
    name: "org-orgId-settings-notifications"
  }, {
    path: "/org/:orgId/settings/online-record-settings",
    component: _e4513e6c,
    name: "org-orgId-settings-online-record-settings"
  }, {
    path: "/org/:orgId/settings/positions",
    component: _f9a42256,
    name: "org-orgId-settings-positions"
  }, {
    path: "/org/:orgId/settings/profile",
    component: _59fa4d54,
    name: "org-orgId-settings-profile"
  }, {
    path: "/org/:orgId/settings/pwa-setup",
    component: _30249ed6,
    name: "org-orgId-settings-pwa-setup"
  }, {
    path: "/org/:orgId/settings/services",
    component: _9ff89df4,
    name: "org-orgId-settings-services"
  }, {
    path: "/org/:orgId/settings/startSettings",
    component: _49eb8e10,
    name: "org-orgId-settings-startSettings"
  }, {
    path: "/org/:orgId/settings/test-kkm",
    component: _3d77c492,
    name: "org-orgId-settings-test-kkm"
  }, {
    path: "/org/:orgId/settings/wallet",
    component: _824253c4,
    name: "org-orgId-settings-wallet"
  }, {
    path: "/org/:orgId/integrations/rostelecom-cloudpbx/calls",
    component: _6b94dd6a,
    name: "org-orgId-integrations-rostelecom-cloudpbx-calls"
  }, {
    path: "/org/:orgId/settings/employees/schedules",
    component: _17599bc0,
    name: "org-orgId-settings-employees-schedules"
  }, {
    path: "/org/:orgId/settings/employees/services",
    component: _1b53f0e0,
    name: "org-orgId-settings-employees-services"
  }, {
    path: "/org/:orgId/settings/notifications/list",
    component: _0f7ad50d,
    name: "org-orgId-settings-notifications-list"
  }, {
    path: "/org/:orgId/settings/services/reorder",
    component: _443675af,
    name: "org-orgId-settings-services-reorder"
  }, {
    path: "/org/:orgId/settings/notifications/list/:id",
    component: _74369296,
    name: "org-orgId-settings-notifications-list-id"
  }, {
    path: "/org/:orgId/settings/branches/:branchId",
    component: _7ff2b23c,
    name: "org-orgId-settings-branches-branchId"
  }, {
    path: "/org/:orgId/settings/services/:serviceId",
    component: _6ffcd62d,
    name: "org-orgId-settings-services-serviceId"
  }, {
    path: "/org/:orgId/calendar/:departmentId?",
    component: _a3e1af9c,
    name: "org-orgId-calendar-departmentId"
  }, {
    path: "/org/:orgId/clients/:clientId",
    component: _b60738cc,
    name: "org-orgId-clients-clientId"
  }, {
    path: "/org/:orgId/employee/:employeeId?/about-me",
    component: _204c07fc,
    name: "org-orgId-employee-employeeId-about-me"
  }, {
    path: "/org/:orgId/employee/:employeeId?/schedule",
    component: _69cfabfb,
    name: "org-orgId-employee-employeeId-schedule"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
